import { useMemo, useEffect } from 'react';
import CustomSelect from './CustomSelect';
import { useCurrentHash } from '../hooks/hashs/useCurrentHash';
import { Container } from '@mui/material';
import { useTripFiltersStore } from '../stores/useTripFiltersStore';
import { useVehiclesStore } from '../stores/useVehiclesStore';
import { useDriversStore } from '../stores/useDriversStore';

const TripFilters = ({ inheritColor = false }) => {

  const situacoesSelecionadas = useTripFiltersStore(state => state.situacoesSelecionadas);
  const situacaoTripsTypes = useTripFiltersStore(state => state.situacaoTripsTypes);
  const setSituacoesSelecionadas = useTripFiltersStore(state => state.setSituacoesSelecionadas);

  const desempenhosSelecionados = useTripFiltersStore(state => state.desempenhosSelecionados);
  const desempenhoTripsTypes = useTripFiltersStore(state => state.desempenhoTripsTypes);
  const setDesempenhosSelecionados = useTripFiltersStore(state => state.setDesempenhosSelecionados);

  const veiculosEmViagem = useVehiclesStore(state => state.veiculosEmViagem);

  const veiculosEmViagemSelecionados = useVehiclesStore(state => state.veiculosEmViagemSelecionados);

  const setVeiculosEmViagemSelecionados = useVehiclesStore(state => state.setVeiculosEmViagemSelecionados);
  
  const allVeiculosIds = useMemo(
    () => veiculosEmViagem.map(v => v.id),
    [veiculosEmViagem]
  );

  const selectedVeiculos = useMemo(
    () =>
      veiculosEmViagemSelecionados === null
        ? allVeiculosIds
        : veiculosEmViagemSelecionados,
    [veiculosEmViagemSelecionados, allVeiculosIds]
  );

  useEffect(() => {

    if (!veiculosEmViagem.length) {
      return;
    }

    if (veiculosEmViagemSelecionados === null) {
      return;
    }

    const validos =
      veiculosEmViagemSelecionados.filter(
        id =>
          veiculosEmViagem.some(
            veiculo =>
              String(veiculo.id) ===
              String(id)
          )
      );

    if (
      validos.length !==
      veiculosEmViagemSelecionados.length
    ) {

      setVeiculosEmViagemSelecionados(validos);

    }

  }, [
    veiculosEmViagem,
    veiculosEmViagemSelecionados,
    setVeiculosEmViagemSelecionados
  ]);

  const driversEmViagem = useDriversStore(state => state.driversEmViagem);

  const driversEmViagemSelecionados = useDriversStore(state => state.driversEmViagemSelecionados);

  const setDriversEmViagemSelecionados = useDriversStore(state => state.setDriversEmViagemSelecionados);

  const allDriversIds = useMemo(
    () =>
      driversEmViagem.map(
        driver => driver.id
      ),
    [driversEmViagem]
  );

  const selectedDrivers = useMemo(
    () =>
      driversEmViagemSelecionados === null
        ? allDriversIds
        : driversEmViagemSelecionados,
    [
      driversEmViagemSelecionados,
      allDriversIds
    ]
  );

  useEffect(() => {

    if (!driversEmViagem.length) {
      return;
    }

    if (driversEmViagemSelecionados === null) {
      return;
    }

    const validos =
      driversEmViagemSelecionados.filter(
        id =>
          driversEmViagem.some(
            driver =>
              String(driver.id) ===
              String(id)
          )
      );

    if (
      validos.length !==
      driversEmViagemSelecionados.length
    ) {

      setDriversEmViagemSelecionados(
        validos
      );

    }

  }, [
    driversEmViagem,
    driversEmViagemSelecionados,
    setDriversEmViagemSelecionados
  ]);

  const { hashElemment } = useCurrentHash();

  return (
    <Container
      sx={{
        backgroundColor: 'inherit !important',
        color: 'inherit !important',
        display: 'flex',
        width: '100% !important',
        justifyContent: 'center',
        paddingX: '0 !important'
      }}
    >
      <CustomSelect
        items={situacaoTripsTypes}
        selected={situacoesSelecionadas}
        onChange={setSituacoesSelecionadas}
        label="Situação da viagem"
        allowNone={false}
        allowAll={true}
        multiple
        inheritColor={inheritColor}
        disabled={hashElemment !== 'TripCard'}
        layout='compact'
      />

      <CustomSelect
        items={desempenhoTripsTypes}
        selected={desempenhosSelecionados}
        onChange={setDesempenhosSelecionados}
        label="Desempenho da viagem"
        allowNone={false}
        allowAll={true}
        multiple
        enabledToggle={true}
        inheritColor={inheritColor}
        disabled={hashElemment !== 'TripCard'}
        layout='compact'
      />

      <CustomSelect
        items={veiculosEmViagem}
        selected={selectedVeiculos}
        onChange={setVeiculosEmViagemSelecionados}
        label="Veículos em viagens"
        allowNone={true}
        allowAll={true}
        multiple
        maxVisibleLabels={1}
        enableSearch={true}
        enabledToggle={true}
        inheritColor={inheritColor}
        disabled={hashElemment !== 'TripCard'}
        layout='compact'
      />

      <CustomSelect
        items={driversEmViagem}
        selected={selectedDrivers}
        onChange={setDriversEmViagemSelecionados}
        label="Motoristas em viagens"
        allowNone={true}
        allowAll={true}
        multiple
        maxVisibleLabels={1}
        enableSearch={true}
        enabledToggle={true}
        inheritColor={inheritColor}
        disabled={hashElemment !== 'TripCard'}
        layout='compact'
      />
      
    </Container>
  );
};

export default TripFilters;